<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row">
            <div class="col-3">
              <h2 class="card-title-desc">En Route Deliveries</h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4" v-if="isUserStaff()">
              <a :href="map_link" target="_blank"><b-button variant="secondary" size="sm" class="py-2 text-white" type="submit">View Map</b-button></a>
            </div>
          </div>
          <TableLoading v-if="deliveries.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="deliveries.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <div class="row mb-2">
                <div class="col-sm-3 col-12">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Warehouse</label>
                    <select class="form-select" v-model="warehouse">
                      <option value="cfa748b0-607b-4dfd-88cb-a1c5e6c7209f">JKIA (MOL)</option>
                      <option value="c5e8bd7e-dbe9-4d37-b50a-8b9dffa0510a">Offshore</option>
                    </select>
                  </div>
                </div>
              </div>
              <template v-slot:actions="slotProps">
                <div class="button-items" v-if="checkForPermission(change_order_status_permission)">
                  <b-button v-if="slotProps.row.status.orderStatusName === 'Open'" variant="primary" size="sm" class="py-1 text-white" @click="customizeOrder(slotProps.row.publicId)">
                    Customize Order
                  </b-button>
                  <b-button v-if="slotProps.row.canCancelOrder && checkForPermission(cancel_order_permission)" variant="danger" size="sm" class="py-1 text-white" @click="cancelOrder(slotProps.row.publicId)">
                    Cancel Order
                  </b-button>
                </div>
              </template>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="deliveries.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import moment from 'moment'
import {ALL_ORDER_DELIVERIES} from "@/gql/orders";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "En Route Deliveries",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "onroute-deliveries",
  data() {
    return {
      title: "En Route Deliveries",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "En Route Deliveries",
          active: true
        }
      ],
      change_order_status_permission: permissions.change_order_status_permission,
      cancel_order_permission: permissions.cancel_order_permission,
      deliveries: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      co_ordinates: [],
      searchKeyword: "",
      today: moment().format('YYYY-MM-DD'),
      warehouse: "cfa748b0-607b-4dfd-88cb-a1c5e6c7209f",
      notDeliveredIds: [
        '37bd4482-06ed-409d-845e-bdc6334c5505', /* Not Loaded */
        'b3180af8-62c8-44ce-8432-64c02c5e5a56', /* Loaded */
      ],
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.name',
          label: 'Customer Name'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'orderTimeZone',
          label: 'Timezone'
        },
        // {
        //   field: 'driver',
        //   label: 'Driver'
        // },
        {
          field: 'orderStatus',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        },
      ]
    }
  },
  apollo: {
    deliveries: {
      query: ALL_ORDER_DELIVERIES,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          deliveryDates: this.today,
          orderStatus: this.notDeliveredIds,
          warehouse: this.warehouse,
          institutionTypes: [
            "e0aaa5be-c975-48f1-b9cf-6b6f925ece32",
            "a8c743f1-1c11-44d8-a526-316748fc0528",
            "54a166c0-a041-4b3f-ad18-b6dac44854d5",
            "df134dc7-8ffa-4a62-83e1-ee06b44e09aa",
            "91936a07-8f2a-4669-8859-0125163f89cd",
            "e67c40b9-7a93-4e51-99a6-05811c34fb87",
            "ab18cf70-8d2b-458c-8dd2-11d717ed2ea1",
            "15c06726-e5aa-4852-a244-fba851c27e34",
            "317b9006-ce33-46b8-aca5-613e3f73a8b1",
            "eb936f18-1aac-4806-b2c9-cf35a06785c1",
            "c0eacdcc-4e26-460a-b090-532a7e74fd85",
            "ed413790-c6ee-446b-afaf-f320349642e1",
          ],
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    deliveries(){
      this.getCoordinates()
    }
  },
  computed: {
    map_link: function () {
      var coordinates = this.co_ordinates
      var size = coordinates.length
      var url = 'https://www.google.com/maps/dir/-1.2894349744452112,36.78767472604342/'
      for (var i = 0; i < size; i++) {
        url = url + coordinates[i].latitude + ',' + coordinates[i].longitude + '/'
      }
      return url
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      changeOrderStatus: 'orders/changeOrderStatus',
    }),
    async cancelOrder(orderId){
      const data = {orderId: orderId ,statusId: "c518ae7e-0732-46cb-b234-da118cdfd8f9"}
      await this.changeOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.orders.refetch()
        }
      })
    },
    customizeOrder(public_id){
      this.$router.push(routeItems.customize_order_route+'/'+public_id)
    },
    searchFn(data){
      this.searchKeyword = data
    },
    getCoordinates(){
      const co_ordinates = []
      this.deliveries.objects.forEach((order)=>{
        co_ordinates.push({
          'latitude': order.customer.lat,
          'longitude': order.customer.longi
        })
      })
      co_ordinates.push({
        'latitude': -1.27012617121754,
        'longitude': 36.803609522090476,
      })
      this.co_ordinates = co_ordinates
    }
  }

}
</script>

<style scoped>

</style>
